import { useBookingModuleStore } from "PFApp/booking/store";
import { AnyFilter } from "PFApp/components/filters/any_filter";
import { useFiltersV2Store } from "PFApp/components/filters_v2";
import { GenericFilterProps } from "PFApp/components/filters_v2/types";
import { Tooltip } from "PFComponents/tooltip";
import { useDateFormatter } from "PFCore/hooks";
import { KnownFiltersV2 } from "PFTypes/filters_v2";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./booking_filters.module.scss";
import { useIsBookingCategoryFilterDisabled } from "./hooks/use_is_booking_category_filter_disabled";

export const BookingCategoryFilterV2 = ({
  autofocus,
  disabled,
  ...genericFilterProps
}: GenericFilterProps) => {
  const { t } = useTranslation("bookingModule");
  const { formatDate } = useDateFormatter();
  const calendarRange = useBookingModuleStore((state) => state.calendarRange);

  const bookingCategoryFilter = useFiltersV2Store(
    (state) => state.buffer.mainFilters[KnownFiltersV2.BookingCategoryId]
  );

  const { isDisabled, message } = useIsBookingCategoryFilterDisabled();

  const calendarRangeLabel = calendarRange
    ? `${formatDate(calendarRange.min)} - ${formatDate(calendarRange.max)}`
    : "";

  return (
    <Tooltip content={message} disabled={!isDisabled} triggerContainerProps={{ className: css.container }}>
      <AnyFilter
        {...genericFilterProps}
        // properties mapping is needed because AnyFilter still use legacy filter type
        filter={{ ...bookingCategoryFilter, query: bookingCategoryFilter.optionsQuery }}
        autofocus={autofocus}
        disabled={isDisabled || disabled}
        labelTooltip={{
          icon: "info",
          text: t("bookings.tooltip.bookingCategoryFilter", { dateRange: calendarRangeLabel })
        }}
      />
    </Tooltip>
  );
};
